module.exports = __webpack_public_path__ + "img/left-nav-bar-1.f1bdffd8.svg";